import {TableRow, styled } from "@mui/material";

export const JanusStyledTableRow = styled(TableRow)(({theme}) => ({
    fontWeight: "500",
    borderBottom: "0"
}));